export const courseList = [
  {
    name: "Jenny Wilson",
    id: "254264",
    course: "3D Character Creation",
    duration: "12h 36m",
    price: "$250",
  },
  {
    name: "Jeevan",
    id: "254265",
    course: "3D Character Creation",
    duration: "12h 36m",
    price: "$120",
  },
  {
    name: "vishnu",
    id: "254268",
    course: "3D Character Creation",
    duration: "12h 36m",
    price: "$68",
  },
  {
    name: " Wilson",
    id: "254264",
    course: "3D Character Creation",
    duration: "12h 36m",
    price: "$250",
  },
];
